import { useNavigate } from "react-router-dom";
import React, { useEffect } from "react";
import axios from "axios";
import Config from "../config";
import "../css/App.css";

function SelectAppPage() {
    const navigate = useNavigate();
    const sites = Config.sites || [];
    const authBaseUrl = Config.authBaseUrl || "";

    useEffect(() => {
        axios
            .get(`${authBaseUrl}/check-auth`, {
                withCredentials: true,
            })
            .then(() => {})
            .catch(() => {
                navigate("/");
            });
    }, [navigate, authBaseUrl]);

    const handleRedirect = async (url) => {
        try {
            const response = await axios.post(
                `${authBaseUrl}/generate-temp-token`,
                {},
                { withCredentials: true },
            );
            const tempToken = response.data.temp_token;
            const separator = url.includes("?") ? "&" : "?";
            window.location.href = `${url}${separator}authToken=${tempToken}`;
        } catch (error) {
            console.error("Error generating temporary token", error);
        }
    };

    return (
        <div className="app-selection-container">
            <div className="app-selection-box">
                <h2>Select a Facility</h2>
                <div className="app-selection-buttons">
                    {sites.map((site) => (
                        <button
                            key={site.label}
                            className="app-button"
                            onClick={() => handleRedirect(site.url)}
                        >
                            {site.label}
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default SelectAppPage;
